export default "__VITE_ASSET__f3e57003__"